import React, { memo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ogImageRu, ogImageUk } from '@/assets/img';
import { LOCALES } from '@/constants';
import { getLocaleUrlPath } from '@/utils';

function PageHelmet({ title = '', description = '', meta = [], ...props }) {
  const { locale } = useIntl();
  const { pathname, search } = useLocation();
  const ogImage = locale === LOCALES.ru ? ogImageRu : ogImageUk;

  return (
    <Helmet
      title={title}
      link={[
        {
          rel: 'canonical',
          href: `https://minfin.com.ua${getLocaleUrlPath(locale)}${pathname}`,
        },
        {
          rel: 'alternate',
          hreflang: 'ru',
          href: `https://minfin.com.ua${pathname}${search}`,
        },
        {
          rel: 'alternate',
          hreflang: 'uk',
          href: `https://minfin.com.ua/ua${pathname}${search}`,
        },
      ]}
      meta={[
        {
          name: 'description',
          content: description,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: description,
        },
        {
          property: 'og:image',
          content: `${process.env.APP_DEPLOY_URL}${ogImage}`,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:url',
          content: `https://minfin.com.ua${pathname}${search}`,
        },
        ...meta,
      ]}
      {...props}
    />
  );
}

PageHelmet.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  scripts: PropTypes.arrayOf(PropTypes.object),
};

export default memo(PageHelmet);
